import { FedevAuthService } from '@bmw-fedev/auth';
import { Router } from '@angular/router';

export const RECOVERY_STAMP_KEY = 'tqc-session-recovery-at';
const RECOVERY_COOLDOWN_MS = 30000;
export const SESSION_EXPIRED_ROUTE = '/session-expired';

let recoveringThisLoad = false;

const lastAttemptAt = (): number =>
  Number(sessionStorage.getItem(RECOVERY_STAMP_KEY) ?? 0);

export const markRecoverySuccess = (): void => {
  recoveringThisLoad = false;
  if (sessionStorage.getItem(RECOVERY_STAMP_KEY) !== null) {
    sessionStorage.removeItem(RECOVERY_STAMP_KEY);
  }
};

export const recoverSession = (
  auth: FedevAuthService,
  router: Router,
  returnUrl: string
): void => {
  if (recoveringThisLoad) {
    return;
  }
  recoveringThisLoad = true;

  const now = Date.now();
  const previousAttempt = lastAttemptAt();
  if (previousAttempt !== 0 && now - previousAttempt < RECOVERY_COOLDOWN_MS) {
    void router.navigateByUrl(SESSION_EXPIRED_ROUTE);
    return;
  }

  sessionStorage.setItem(RECOVERY_STAMP_KEY, String(now));
  auth.logout();
  void auth.tryLogin(returnUrl);
};
